import script from "./FourthIhramPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FourthIhramPage.vue?vue&type=script&setup=true&lang=js"

import "./FourthIhramPage.vue?vue&type=style&index=0&id=324bd9b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-324bd9b8"]])

export default __exports__